// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2pE-Z","head":"Table_head__1V_08","col":"Table_col__3gDNd"};